import React from 'react'
import CustomerLists from '../components/crm/customerLists'

export default function CustomerList() {
  return (
    <CustomerLists/>
  )
}
